import React from 'react'
import styled from '@emotion/styled'
import { Part__Custom_switch } from '../../parts-components'

const Icon = (props) => (
  /* eslint-disable react/jsx-pascal-case */
  <Part__Custom_switch {...props} width={21} height={21} />
)

export default styled(Icon)`
  position: relative;
  top: 2px;
  left: 2px;
  z-index: 100;
`
